<script lang="ts">
// Module scope (runs once, outside setup): shared by every mounted host instance.
let mountedHosts = 0
</script>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue'
import { acceptConfirm, confirmState, dismissConfirm } from '@/composables/useConfirm'

// The host is mounted by both App.vue and the app layout so component tests that render a
// page (or a layout) on its own still get a working prompt. Only the first instance to
// mount renders, which keeps the real app from stacking two dialogs.
const isActive = ref(false)

onMounted(() => {
  if (mountedHosts === 0) isActive.value = true
  mountedHosts += 1
})

onUnmounted(() => {
  mountedHosts -= 1
  if (mountedHosts === 0) isActive.value = false
})

function handleOpenChange(open: boolean) {
  if (!open) dismissConfirm()
}
</script>

<template>
  <ConfirmDialog
    v-if="isActive"
    :open="confirmState.open"
    :title="confirmState.title"
    :message="confirmState.message"
    :confirm-text="confirmState.confirmText || undefined"
    :cancel-text="confirmState.cancelText || undefined"
    :danger="confirmState.danger"
    :loading="confirmState.loading"
    :close-on-confirm="false"
    @confirm="acceptConfirm"
    @cancel="dismissConfirm"
    @update:open="handleOpenChange"
  />
</template>
